import { createSlice } from '@reduxjs/toolkit';
import {logout} from "./authenticationSlice";

const kpiSlice = createSlice({
    name: 'kpi',
    initialState: {
        selectedYear: new Date().getFullYear(),
        selectedView: 0,
        selectedDashboard: 0
    },
    reducers: {
        selectYear: (state, action) => {
            state.selectedYear = action.payload;
        },
        selectView: (state, action) => {
            if(action.payload < 0) {
                state.selectedView = 2;
            }
            else {
                state.selectedView = action.payload;
            }
        },
        selectDashboard: (state, action) => {
            if(action.payload < 0) {
                state.selectedDashboard = 1;
            }
            else {
                state.selectedDashboard = action.payload;
            }
        }
    },
    extraReducers: builder =>
        builder.addCase(logout, (state) => {
            state.selectedYear = new Date().getFullYear();
        })
});

export const {
    selectYear,
    selectView,
    selectDashboard
} = kpiSlice.actions;

export default kpiSlice.reducer;
